<script lang="ts" setup>
import WidgetLayout from './WidgetLayout.vue'

const { color } = defineProps<{
  color?: string
}>()

const selectedColor = computed(() => {
  return color || '#E8E8E8'
})
</script>

<template>
  <WidgetLayout class-name="!pb-0">
    <div class="widget-header flex flex-col items-start justify-between gap-4">
      <div
        class="w-full h-[1px] mt-1 xl:mt-2 mb-2 xl:mb-5"
        :style="{
          backgroundColor: selectedColor,
        }" />
    </div>
  </WidgetLayout>
</template>
